export default "__VITE_ASSET__CNCsvg4t__"